export const environment = {
  production: true,
  endpoint: 'https://api-breello-dev.fromscratch-apis.com',
  frontOfficeURL: 'https://breello-dev.fromscratch-apis.com',
  googleClientId: '148785049552-enr0s0v7n1ccvrdle8462vec2qopujo9.apps.googleusercontent.com',
  facebookClientId: '1170387223488336',
  hotjarTrackingId: '2589129',
};
